import { PasswordInputGroup } from "../../form/PasswordInputGroup";
import { postUrlEncoded } from "../../LegacyAxiosUtil";
import { StepType } from "../StepType";
import { RegisterStep } from "./RegisterStep";
import { Tracking } from "../../../tracking/Tracking";
import Log from "@/utils/Log";

/// mobile-detect is a UMD, we can not "import" it, see https://github.com/Microsoft/TypeScript/issues/10178
// eslint-disable-next-line no-var
declare var MobileDetect: any;

export class RegisterChild extends RegisterStep {
	private childFirstName: JQuery;

	constructor(step: JQuery) {
		super(step, StepType.RegisterChild);
		this.step = step;
		this.childFirstName = jQuery("#childFirstName");
	}

	public onStepLoad(): void {
		this.childFirstName = jQuery("#childFirstName");
		if (!new MobileDetect(window.navigator.userAgent).mobile()) {
			this.childFirstName.focus();
		}
		// eslint-disable-next-line no-new
		new PasswordInputGroup(this.step.find(".mia-PasswordInputGroup"));
	}

	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	public setUpValidation(rules: any): void {
		rules.childFirstName = {
			maxlength: this.childFirstName.data("max-length"),
			normalizer: (value: string) => {
				return value.trim();
			},
			required: true,
		};
	}

	public async onStepChanging(_newStepType: StepType): Promise<boolean> {
		this.showProgressIndicator(true, "", true);

		const validateUrl = this.step.find(".mia-StepBody").data("validate-url");
		try {
			const { data } = await postUrlEncoded<{ success: boolean, errorMessage?: string }>(validateUrl, this.wizardData);

			if (!data.success && data.errorMessage) {
				this.showErrorMessage(data.errorMessage);
			}

			return data.success;
		}
		catch (error) {
			void Log.error("RegisterChild.onStepChanging request failed", error);
			return false;
		}
		finally {
			this.hideProgressIndicator();
		}
	}

	public trackCompletedStep(): void {
		Tracking.TrackStudentRegistrationStepCompleted();
	}

	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	public fillInData(data: any): void {
		data.childFirstName = this.childFirstName.val();
		data.childLastName = this.step.find("#childLastName").val();
		data.childPassword = this.step.find("#childPassword").val();
	}
}
